











import './KisweCollapse.scss'
import { defineComponent } from '@vue/composition-api'
import { Collapse } from 'element-ui'

export default defineComponent({
  name: 'KisweCollapse',
  components: {
    'el-collapse': Collapse
  },
  props: {
    value: {
      type: Array as () => string[],
      required: false,
      default: () => []
    },
    useAccordionMode: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: {
    change (_activeNames: string[]) { return true }
  },
  methods: {
    onChange (newVal: string[]|string) {
      let activeCollapseNames = newVal
      if (typeof newVal === 'string') activeCollapseNames = [newVal]
      this.$emit('change', activeCollapseNames)
    }
  }
})
